"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lnStyle = exports.ecoAtmoStyle = exports.atmoStyle = exports.ecoStyle = exports.oceanStyle = exports.countryBorderStyle = exports.countryStyle = exports.trianglePointStyle = exports.cirlcePointStyle = void 0;
const Style_1 = __importDefault(require("ol/style/Style"));
const Fill_1 = __importDefault(require("ol/style/Fill"));
const Stroke_1 = __importDefault(require("ol/style/Stroke"));
const Circle_1 = __importDefault(require("ol/style/Circle"));
const RegularShape_1 = __importDefault(require("ol/style/RegularShape"));
const cirlcePointStyle = (fillColor, strokeColor, radius, strokeWidth) => new Style_1.default({
    image: new Circle_1.default({
        radius,
        fill: new Fill_1.default({ color: fillColor }),
        stroke: new Stroke_1.default({ color: strokeColor, width: strokeWidth })
    })
});
exports.cirlcePointStyle = cirlcePointStyle;
const trianglePointStyle = (fillColor, strokeColor, radius, strokeWidth) => new Style_1.default({
    image: new RegularShape_1.default({
        radius,
        fill: new Fill_1.default({ color: fillColor }),
        stroke: new Stroke_1.default({ color: strokeColor, width: strokeWidth }),
        points: 3,
    }),
});
exports.trianglePointStyle = trianglePointStyle;
const oceanColor = 'rgb(92,43,147)';
// Eco is officially rgb(174,192,0), made brighter in map
const ecoColor = 'rgb(195,213,0)';
const atmoColor = 'rgb(228,28,100)';
const ecoAtmoColor = 'rgb(0,171,201)';
exports.countryStyle = new Style_1.default({
    fill: new Fill_1.default({
        color: 'PapayaWhip'
    }),
    stroke: new Stroke_1.default({
        color: 'DimGray',
        width: 1
    })
});
exports.countryBorderStyle = [
    new Style_1.default({
        stroke: new Stroke_1.default({
            color: 'DarkGray',
            width: 2
        })
    }),
    new Style_1.default({
        stroke: new Stroke_1.default({
            color: 'DarkSlateGray',
            width: 1
        })
    })
];
exports.oceanStyle = (0, exports.cirlcePointStyle)(oceanColor, 'black', 4, 1);
exports.ecoStyle = (0, exports.cirlcePointStyle)(ecoColor, 'black', 4, 1);
exports.atmoStyle = (0, exports.cirlcePointStyle)(atmoColor, 'black', 4, 1);
exports.ecoAtmoStyle = (0, exports.cirlcePointStyle)(ecoAtmoColor, 'black', 4, 1);
exports.lnStyle = new Style_1.default({
    stroke: new Stroke_1.default({
        color: oceanColor,
        width: 2
    })
});
